import React from 'react';
import Icon from '../Icon/Icon';
var css = {
  "root": "rui-T8KRZ",
  "imgContainer": "rui-mSbNR",
  "img": "rui-9TssB",
  "wrapper": "rui-SXolR",
  "main": "rui-KgFYP",
  "caption": "rui-fVNuj"
};
var ButtonBox = function ButtonBox(_ref) {
  var children = _ref.children,
    caption = _ref.caption,
    src = _ref.src,
    alt = _ref.alt,
    icon = _ref.icon,
    webpImage = _ref.webpImage;
  return /*#__PURE__*/React.createElement("div", {
    className: css.root
  }, src ? /*#__PURE__*/React.createElement("picture", {
    className: css.imgContainer
  }, webpImage && /*#__PURE__*/React.createElement("source", {
    type: "image/webp",
    srcSet: webpImage
  }), /*#__PURE__*/React.createElement("img", {
    className: css.img,
    src: src,
    alt: alt
  })) : icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: 60
  }), /*#__PURE__*/React.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css.main
  }, children), /*#__PURE__*/React.createElement("div", {
    className: css.caption
  }, caption)), /*#__PURE__*/React.createElement(Icon, {
    icon: "arrowRight",
    size: 24
  }));
};
ButtonBox.defaultProps = {
  caption: '',
  src: '',
  alt: '',
  icon: ''
};
export default ButtonBox;